import { render, staticRenderFns } from "./Recharge.vue?vue&type=template&id=0fff8bef&scoped=true&"
import script from "./Recharge.vue?vue&type=script&lang=ts&"
export * from "./Recharge.vue?vue&type=script&lang=ts&"
import style0 from "./Recharge.vue?vue&type=style&index=0&id=0fff8bef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../namtrung_logistics/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fff8bef",
  null
  
)

export default component.exports